import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = [{
  title: 'Comprás stock y no vendés',
  desc: 'Apostás tus ahorros en prendas que terminan guardadas en bolsas, sin saber si había demanda real antes de invertir.'
}, {
  title: 'No sabés cuánto cobrar',
  desc: 'Ponés precios a ojo, vendés "barato para competir" y al final del mes descubrís que trabajaste para nada o perdiste plata real.'
}, {
  title: 'Los proveedores te fallan',
  desc: 'Te prometen calidad y tiempo de entrega, pero llega tarde, con tela diferente o directamente no contestan más el teléfono.'
}, {
  title: 'Tu Instagram no convierte',
  desc: 'Publicás fotos, recibís "me gusta" pero nadie pregunta el precio, y los que preguntan se desaparecen cuando respondés.'
}, {
  title: 'No sabés por dónde empezar',
  desc: 'Tenés la idea, las ganas y quizás algo de capital, pero el camino está tan desordenado que terminás sin ejecutar nada.'
}, {
  title: 'La inflación te come el margen',
  desc: 'Calculás mal los costos sin considerar inflación, comisiones, packaging y envíos. El precio que pusiste ayer hoy ya no cierra.'
}];
export function PainPoints() {
  return <section aria-label="Problemas" className="border-y border-white/5 bg-ink-2" data-id="element-107" data-mp="27s7ad6mowhbh">
      <div className="mx-auto max-w-4xl px-5 pt-[5px]" data-id="element-108" data-mp="23rx37qn5vkv1">
        <h2 className="pt-[24px] text-center font-display text-[25px] font-black text-white sm:text-4xl" data-id="element-109" data-mp="1g1at7ttljqie">
          ❌ ¿Cuánta plata más vas a perder sin un sistema?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-110" data-mp="1p2hdmdzd9lgx">
          Sos emprendedor. Querés vender ropa. Pero nadie te dijo que ibas a pasar semanas buscando
          proveedores que fallan, calculando precios mal y publicando fotos que nadie compra.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-celeste" data-id="element-111" data-mp="2vil0uspmm83y">
          No es falta de capital. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-112" data-mp="1t7hqcf74mw6d">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-113" data-mp="1y6chc4f8zr1k" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-celeste/20 text-celeste-soft" data-id="element-114" data-mp="1eh25x2mjbs99">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-115" data-mp="1jdis3ra6bwjp" />
              </span>
              <div data-id="element-116" data-mp="1o7d9go2b3zfm">
                <h3 className="text-sm font-bold text-white" data-id="element-117" data-mp="1o7wtcabioxwa">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-118" data-mp="qqeif904yu1l">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 pb-12 text-center" data-id="element-119" data-mp="o6rugchm3hwf">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-120" data-mp="o45qsnxudmjh">
            ¿Y si este fuera el último mes que emprendés sin un método real?
          </p>
          <p className="mt-3 text-lg font-semibold text-gold" data-id="element-121" data-mp="e6r9yn80avqn">
            Tu primera cápsula de ropa puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}